<template>
  <div class="main-con">
    <div class="list-item">
      <div class="item-row">
        <span>监管记录</span>
        <span>以下信息由主体提供</span>
      </div>
      <div class="info">
        <h1>监管机构</h1>
        <h1>重庆黑黑黑农业专业合作社</h1>
      </div>
      <div class="info">
        <h1>监管时间</h1>
        <h1>合作社</h1>
      </div>
      <div class="info">
        <h1>监管人员</h1>
        <h1>种植业,畜禽养殖业,水产养殖业,种养结合</h1>
      </div>
      <div class="info">
        <h1>监管内容</h1>
        <h1>种植业,畜禽养殖业,水产养殖业,种养结合</h1>
      </div>
      <div class="info">
        <h1>检测结果</h1>
        <h1 class="result">合格</h1>
      </div>
      <!-- <div>
        <img src="" alt="" />
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  props: {},
  watch: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.main-con {
  width: 100%;
  height: 100%;
  padding: 0.2rem;
  // overflow: scroll;
  box-sizing: border-box;
  .list-item {
    background-color: #fff;
    border-radius: 0.16rem;
    padding: 0.2rem;
    margin-bottom: 0.2rem;
    .item-row {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #f1f1f1;
      padding-bottom: 0.2rem;
      span {
        &:nth-child(1) {
          font-weight: 600;
        }
        &:nth-child(2) {
          color: #33bd7d;
          font-size: 0.24rem;
          font-weight: 600;
        }
      }
    }
    .info {
      line-height: 0.5rem;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      h1 {
        &:nth-child(1) {
          width: 20%;
        }
        &:nth-child(2) {
          color: #333;
          flex: 1;
          font-weight: 600;
        }
      }
      .result {
        color: #33bd7d !important;
      }
    }
  }
}
</style>
